export default {"src":"/_next/static/image/src/components/icons/place.c72c8af3351685571340d2d7a4730ff2.svg","height":24,"width":24};